<template>
    <span>
        <span v-if="this.datetimeDeliveryTakeaway">
            {{moment(this.datetimeDeliveryTakeaway).locale(language).format('dddd DD').toUpperCase()}}
            {{$t('ore_in_data')}}
            {{moment(this.datetimeDeliveryTakeaway).format('HH:mm')}}
        </span>
        <span v-if="this.deliveryTakeawayEndSlot">
            - {{moment(this.deliveryTakeawayEndSlot, 'HH:mm:ss').format('HH:mm')}}
        </span>
    </span>
</template>

<script>
    export default {
        name: "IncOrderDatetime",
        props: ['datetimeDeliveryTakeaway', 'deliveryTakeawayEndSlot', 'language']
    }
</script>
